var _rect, _path, _rect2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFillPDownload = function SvgFillPDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66.667,
    height: 46.667,
    x: 6.667,
    y: 15,
    fill: "#C7DEFE",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A8AFB6",
    d: "M31.667 61.666h16.667v10H31.667z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 26.667,
    height: 5,
    x: 26.667,
    y: 66.666,
    fill: "#C8CED4",
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8CED4",
    d: "M6.667 53.334h66.666v4.333a4 4 0 0 1-4 4H10.667a4 4 0 0 1-4-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A8CFF",
    d: "M32.57 10a2.763 2.763 0 0 0-2.755 2.77v12.036h-5.388c-2.427 0-3.668 2.929-1.987 4.69l15.573 16.319a2.743 2.743 0 0 0 3.974 0l15.573-16.32c1.681-1.76.44-4.689-1.987-4.689h-5.388V12.771c0-1.53-1.233-2.771-2.754-2.771z"
  })));
};
export default SvgFillPDownload;